import store from '@/store'
export default [
  {
    path: '/student-follow-ups',
    name: 'student-follow-up',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-follow-up/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('productLocation/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/student-follow-ups/create',
    name: 'student-follow-up-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-follow-up/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('productLocation/dataBeforeCreate')
      next()
    }
  }
]
